import styled from "styled-components"
import {Label} from "@irati/ui/src/Typography"

const CustomTrophyText = styled(Label)`
  left: 0px;
  position: absolute;
  text-align: center;
  width: 120px;
`

export default CustomTrophyText
